<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="alertModal" tabindex="-1" role="dialog" aria-labelledby="interestModalLabel" aria-hidden="true">
            <div class="modal-dialog" v-bind:class="position === 'desktop' ? 'desktop' : 'mobile'" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" >Perhatian</h5>
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button> -->
                    </div>
                    <div class="modal-body">
                        <div class="text-center" v-if="loading">
                            <pulse-loader color="#EC550E"></pulse-loader>
                        </div>
                        <div v-else>
                             <h4><i class="fa fa-user" aria-hidden="true"></i> Mau poin tambahan? Yuk update profil arkadia.me kamu sekarang!</h4>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <router-link :to="'profile/edit'" class="btn btn-primary">Edit Profile</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import _ from "lodash"
import moment from "moment";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
    props: ['position'],
    components: {
        PulseLoader
    },
    data() {
        return {
           
            loading: true
        }
    },
    async mounted() {
        this.loading = false;    
        
        $(`#alertModal`).modal({
            backdrop: 'static',
            keyboard: false
        });
         
    },
    methods: {}
}
</script>
<style scoped>
.modal-header{
    border-bottom: none;
}
.modal-footer {
    border-top: none;
}
@media (min-width: 576px) {
    .modal-dialog {
        max-width: 60%;
        margin: 1.75rem auto;
    }
}
.modal-dialog.desktop {
    top: 10%;
}
.modal-dialog.mobile {
    position: absolute;
    bottom: 0;
}
</style>
